import request from "../../../../utils/api";

const url = "branches";

export const getBranchList = params => request(url, { params });
export const deleteBranch = body => request(`${url}/${body}`, { method: 'delete' });
